import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const TOKEN_KEY = "yvola_token";
export const TENANT_KEY = "yvola_tenant_id";

const api = axios.create({ baseURL: `${BASE}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const tenantId = localStorage.getItem(TENANT_KEY);
  if (tenantId) config.headers["X-Tenant-Id"] = tenantId;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const apiError = (err, fallback = "Eroare") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const msg = detail
      .map((d) => (typeof d === "string" ? d : d?.msg))
      .filter(Boolean)
      .join(", ");
    if (msg) return msg;
  }
  return fallback;
};

export default api;
